export type DeviceOperationMode = 'on/off' | 'toggle' | 'delay';

export interface DeviceAssociation {
  id: string | number;
  propertyId: number;
  deviceId: string;
  operation_modes?: unknown;
  createdby?: string;
  created_by?: string;
  createdBy?: string;
  deviceDetails?: {
    device_type?: string;
    channel?: number;
    label?: string;
    icon?: string;
    operation_modes?: unknown;
    createdby?: string;
    created_by?: string;
    createdBy?: string;
  };
}

export interface SmartDevice {
  id: string;
  propertyId: number;
  deviceId: string;
  deviceType: string;
  channel: number;
  label: string;
  createdBy: string;
  icon: string;
  modes: DeviceOperationMode[];
  isOn: boolean;
  pending: boolean;
  error: string;
}

export interface DevicePremise {
  propertyId: number;
  unitNumber: number;
  displayName: string;
}

export interface DeviceAccessRequest {
  id: string | number;
  deviceId?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  approved?: boolean;
  deviceDetails?: { label?: string };
}

export function parseDeviceModes(value: unknown): DeviceOperationMode[] {
  let raw: unknown[] = [];
  if (Array.isArray(value)) {
    raw = value;
  } else if (typeof value === 'string') {
    try {
      const decoded: unknown = JSON.parse(value);
      if (Array.isArray(decoded)) {
        raw = decoded;
      }
    } catch {
      raw = [];
    }
    if (!raw.length) {
      raw = value.split(',').map(mode => mode.replace(/["'\[\]{}]/g, ''));
    }
  }
  const modes = new Set<DeviceOperationMode>();
  for (const value of raw) {
    const mode = String(value).toLowerCase().trim().replace(/[\s_-]/g, '');
    if (mode === 'on/off' || mode === 'onoff') {
      modes.add('on/off');
    } else if (mode === 'toggle' || mode === 'delay') {
      modes.add(mode);
    }
  }
  return modes.size ? [...modes] : ['toggle'];
}

export function parseDeviceQr(raw: string): Record<string, string[]> {
  const result: Record<string, string[]> = {};
  for (const segment of raw.split(';')) {
    const separator = segment.indexOf(':');
    if (separator < 0) {
      continue;
    }
    const key = segment.slice(0, separator).trim();
    (result[key] ??= []).push(segment.slice(separator + 1).trim());
  }
  return result;
}
